import React from "react";

function Modifyadmin()
{
    return(
        <>
  
        <h2>Admin Modify Information</h2>
        </>
    )

}
export default  Modifyadmin;